export default {
      id: "pay_tinkoff-usage",
      viewBox: "0 0 54 24",
      url: __webpack_public_path__ + "sprite.svg#pay_tinkoff",
      toString: function () {
        return this.url;
      }
    }